export const DEFAULT_FEATURE_FLAGS = [
  'fe_property_views',
  'fe_ui_docs',
  'fe_buy_boxes',
];
